import { ApiService, ObserverService, ContentService, PortfolioService, LessonService } from '@DavisDigital/davisdigitalfrontend.module';
import { FolderTypes, EVENTS } from '@DavisDigital/interfaces';

class SaveAsModalController {
	public lesson: any;
	public portfolioPage: any;
	
	public selectedFolder:any;
	public title:string;
	public description:string;
	public loading:boolean;
	
	public type:FolderTypes;
	
	public showNewFolder:boolean;
	public newFolderName:string;
	public folders:Array<any>;
	public addingFolder:boolean;
	
	public folderLessons:any={};
	public saveEvent:string;
	public setEvent:string;
	public selectedFolderLessons:Array<any>=[];
	
	public folderPortfolios = {};
	public selectedFolderPortfolios: Array<any> = [];
	
	public saveStep:number = 1;
	public multiStepSave:boolean = false;
	public districtAccounts:Array<any> = [];
	public portfolioFacultyAccount:string = "";
	public davisAccountType:string;
	
	// @ngInject
	constructor(
		public ModalService,
		public apiService		: ApiService,
		public lessonService    : LessonService,
		public contentService   : ContentService,
		public observerService  : ObserverService,
		public portfolioService : PortfolioService
	){}
	
	public $onInit = () => {
		//Load faculty,admin accounts when saving not shared portfolio
		this.contentService.getAccountsListForShare({shareWithoutAccessOnly: true, ignoreStudentAccounts: true, ignoreAdminAccounts: false}).then( (response)=>{
			if( this.type === FolderTypes.Portfolio && response.data.accountType == "Student") {
					this.districtAccounts = response.data.accountsWithoutAccess;
					this.multiStepSave = true;
			}
		});
		
	}

	
	public selectFolder = (folder:any)=>{
		let folderID = 'null';
		if(folder == undefined){
			this.selectedFolder = null;
		} else {
			this.selectedFolder = folder;
			folderID = folder.folderID;
		}
		
		if(this.type == FolderTypes.Lesson){
		    this.reloadLessons(folderID);
		} else {
		    this.reloadPortfolios(folderID);
		}
	}
	
	private reloadLessons(folderID: string){
	    if(this.folderLessons[folderID]){
			this.selectedFolderLessons = this.folderLessons[folderID];
			return;
		}
		
		this.loading = true;
		let data:any = {
			pageShow:10,
			folderID:folderID
		};
		
		this.apiService.request('davisdigital:api.getMyLessons', data)
		.then(result=>{
			if(result.data){
				result = result.data;
				if(result.data && result.data.records){
					this.folderLessons[folderID] = result.data.records;
				}
				this.selectedFolderLessons = this.folderLessons[folderID];
				this.loading = false;
			}
		})
	}
	
	
	private reloadPortfolios(folderID: string){
	    if(this.folderPortfolios[folderID]){
			this.selectedFolderPortfolios = this.folderPortfolios[folderID];
			return;
		}
		
	    this.loading = true;
		let data:any = {
			pageShow:10,
			folderID:folderID
		};
		
		this.portfolioService.getMyPortfolios(data)
		.then( result => {
			if(result?.data?.records){
				this.folderPortfolios[folderID] = result.data.records;
				this.selectedFolderPortfolios = this.folderPortfolios[folderID];
			}
			this.loading = false;
		})
		//TODO: handle errors
		.catch(console.error);
	}

	
	public addNewFolder = () => {
		this.addingFolder = true;
		if(this.newFolderName){
		    this.contentService
		    .createFolder( this.newFolderName, this.type )
    		.then( result => {
    			if(result?.data){
    				if(result?.successfulActions?.length && result.data){
    					this.folders.push(result.data);
    				}
    				this.showNewFolder = false;
    				this.addingFolder = false;
    			}
    		})
    		//TODO: handle errros
    		.catch(console.error);
		}
	}
	
	public save = () => {
	    if(this.type === FolderTypes.Lesson){
		    this.saveLesson(
		        this.title,
		        this.selectedFolder?.folderID,
		        this.lesson,
		        this.description
		   );
	    	
	    } else{
	    	 //IF it's portfolio 
	    	 //Show next step if its a multiStep form and current step is 1
	    	if(this.saveStep == 1 && this.multiStepSave){
			    this.setSaveStep(2);
			} else{
				this.savePortfolioPage(
			        this.title,
			        this.selectedFolder?.folderID,
			        this.portfolioPage,
			        this.portfolioFacultyAccount
			   );
				
			}
	    }
	}
	
	public setSaveStep = (step) => {
		this.saveStep = step;
	}
	
	private saveLesson(title:string, folderID: string, lesson?: any, description?: string){
	    this.loading = true;
	    
	    this.lessonService
	    .createLesson(title, folderID, lesson, description)
	    .then( (response) => {
			
			if(response.errors){
				this.observerService.notify(EVENTS.SET_LESSON_ERRORS, response.errors);
				
			} else if(response.data){
				var saveEvent = this.saveEvent ? this.saveEvent : EVENTS.SET_LESSON
				this.observerService.notify(saveEvent, response.data);
			}
			this.close();
			this.loading = false;
	    })
	    .catch((error) => {
	        console.error(error);
	        this.loading = false;
	        this.close();
	    })
	}
	
	private savePortfolioPage(title:string, folderID: string, portfolioPage ?: object, portfolioFacultyAccount ?: string){
	    this.loading = true;
	    
	    this.portfolioService
	    .createPortfolioPage(title, folderID, portfolioPage, "", portfolioFacultyAccount )
	    .then( (response) => {
			
			this.loading = false;
			
			if(response.data){
				var saveEvent = this.saveEvent ? this.saveEvent : EVENTS.SET_PORTFOLIO_PAGE;
				
				this.observerService.notify(saveEvent, response.data.portfolioPage);
				this.close();
			}
	    })
	    //TODO: handle errors
	    .catch(console.error)
	}
	
	public close = () =>{

		var modalToCloseIndex = 0;
		if(this.ModalService.openModals.length === 2){
			modalToCloseIndex = 1;
		}
		//This is a workaround ModalService technically does not support more than one modal
		if(this.ModalService.openModals[modalToCloseIndex]){
			this.ModalService.openModals[modalToCloseIndex].modal.element.modal('hide');
			this.ModalService.openModals.splice(modalToCloseIndex, 1);
		}
	}
}

class SaveAsModal {
	
	public restrict: string = 'E';
	public scope: boolean = true;
	
	public bindToController: any = {
		type:'=',
		folders:'=',
		lesson:'=?',
		portfolioPage:'=?',
		saveEvent:'=?',
		setEvent:'=?',
		davisAccountType:'=?',
	};

	public controller = SaveAsModalController;
	public controllerAs = 'saveAsModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/save-as-modal.html';

	public static Factory() {
		return () => new this();
	}

}

export { SaveAsModal };
